import { createFileRoute } from '@tanstack/react-router'
import BrandsPage from '@/pages/brands'

export const Route = createFileRoute('/brands')({
  component: BrandsPage,
})
